/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext } from "react";
import { LinkContext } from "cms/links/link-selector/context";
import { DefaultAddLinkButton } from "cms/links/link-selector/exported/add-button";
import { DefaultDisplayComponent } from "cms/links/link-selector/exported/display-component";
import { objectHasPropertyString, exists } from "utils/empty-exists";

const LinkDisplay = (props) => {
    
    const { AddComponent, DisplayComponent } = props;
    const {
        setOpen,
        link,
        onSaveLink,
        onRemove,
        onChange,
    } = useContext(LinkContext);
    
    const hasLink = objectHasPropertyString(link, "guid");
    
    // Display the selected link
    // also launches the selector to 'select' or 'remove' the link
    if (hasLink) {
        return (
            <Fragment>
                {exists(DisplayComponent) &&
                    <DisplayComponent
                        link={link}
                        setOpen={setOpen}
                        onClick={() => setOpen(true)}
                        onRemove={onRemove}
                        onChange={onChange}
                        onSaveLink={onSaveLink}
                    />
                }
                {!exists(DisplayComponent) &&
                    <DefaultDisplayComponent
                        link={link}
                        setOpen={setOpen}
                        onClick={() => setOpen(true)}
                        onRemove={onRemove}
                        onChange={onChange}
                        onSaveLink={onSaveLink}
                    />
                }
            </Fragment>
        );
    }
    
    // Show a button to launch the Link Selector
    if (!hasLink) {
        return (
            <Fragment>
                {exists(AddComponent) &&
                    <AddComponent
                        // Dynamic Component: this calls your passed-in React Component to serve as am Add Button (when empty)
                        setOpen={setOpen}
                    />
                }
                {!exists(AddComponent) &&
                    <DefaultAddLinkButton
                        setOpen={setOpen}
                    />
                }
            </Fragment>
        );
    }
};

export { LinkDisplay };
